import services from "../../../http/index";
import * as types from "./mutations-types";
import * as types_customers from "../../customers/store/mutations-types";
import * as types_sessions from "../../sessions/store/mutations-types";
import router from "../../../router";

export const ActionDoLogin = ({ commit, dispatch }, payload) => {
    return services.api.request({
        url: "auth/login",
        method: "post",
        data: payload
    }).then(async response_data => {
        let response = response_data.data;

        if (response.error === "" && response.token) {
            commit(types.SET_TOKEN, response.token);
            
            // Buscar dados completos do usuário com perfil
            await dispatch('ActionGetCurrentUser');
            
        }

        return response;
    });
};

export const ActionDoLogout = ({ commit }) => {
    return services.api.request({
        url: "auth/logout",
        method: "post"
    }).then(() => {
        commit(types.SET_USER, null);
        commit(types.SET_TOKEN, null);
        commit(types.SET_ACCESS_PROFILE, null);
        commit("customers/" + types_customers.SET_CUSTOMERS_LIST, null, { root: true });
        commit("sessions/" + types_sessions.SET_SESSION_LIST, null, { root: true });

        router.push({ name: "auth" });
    });
};

export const ActionRecoverPassword = (context, payload) => {
    return services.api.request({
        url: "auth/forgot-password",
        method: "post",
        data: payload
    });
};

export const ActionResetPassword = (context, payload) => {
    return services.api.request({
        url: "auth/reset-password",
        method: "post",
        data: payload
    });
};

export const ActionGetCurrentUser = ({ commit }) => {
    return services.api.request({
        url: "user",
        method: "get"
    }).then(response => {
        commit(types.SET_USER, response.data);
        commit(types.SET_ACCESS_PROFILE, response.data.access_profile);
        // O perfil será extraído automaticamente pela mutation SET_USER
        return response.data;
    });
};

export const ActionRefreshProfile = ({ commit }) => {
    return services.api.request({
        url: "user",
        method: "get"
    }).then(response => {
        if (response.data.access_profile) {
            commit(types.SET_ACCESS_PROFILE, response.data.access_profile);
        }
        return response.data.access_profile;
    });
};

export const ActionRegister = (context, payload) => {
    return services.api.request({
        url: "auth/register",
        method: "post",
        data: payload
    });
};

export const ActionVerifyEmail = (context, payload) => {
    return services.api.request({
        url: "auth/verify-email",
        method: "post",
        data: payload
    });
};

export const ActionGetServices = () => {
    return services.api.request({
        url: "auth/services",
        method: "get"
    });
};

